/* ===========================================================================
   Benzin — Champagne Tour 2026 · interactions (scope .dm-bz)
   - Carrousel hébergement (auto-advance, swipe, points, hint)
   - Sélecteur de formule (Partagée / Individuelle) câblé aux variantes
   - Soumission AJAX du formulaire produit (/cart/add.js -> /cart, fallback natif)
   La page EN (vitrine) réutilise ce fichier : les blocs absents sont simplement ignorés.
   =========================================================================== */
(function () {
  'use strict';

  // Mémorise la page + la marque pour le panier : « Retour vers le site » et le
  // branding du panier vide doivent ramener vers Benzin, pas vers un créateur visité avant.
  try {
    localStorage.setItem('dm_return_url', window.location.pathname);
    localStorage.setItem('dm_cart_brand', 'benzin');
  } catch (e) {}

  function eur(cents) {
    var v = (parseInt(cents, 10) || 0) / 100;
    var hasDec = Math.round(v * 100) % 100 !== 0;
    try {
      return v.toLocaleString('fr-FR', { minimumFractionDigits: hasDec ? 2 : 0, maximumFractionDigits: 2 }) + ' €';
    } catch (e) {
      return (hasDec ? v.toFixed(2).replace('.', ',') : String(v)) + ' €';
    }
  }

  function init(root) {
    /* ---------- Sélecteur de formule ---------- */
    var rooms = root.querySelectorAll('.bz-room');
    var elTotal = root.querySelector('[data-bz-total]');
    var elAcompte = root.querySelector('[data-bz-acompte]');
    var elSolde = root.querySelector('[data-bz-solde]');
    var elNote = root.querySelector('[data-bz-acompte-note]');
    var elVariant = root.querySelector('[data-variant-id]');
    var elQty = root.querySelector('[data-qty-input]');

    function isSold(b) { return !!b && (b.classList.contains('is-soldout') || b.disabled); }

    function applyRoom(btn) {
      if (!btn || isSold(btn)) return;   // une formule épuisée n'est pas sélectionnable
      rooms.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      var price = parseInt(btn.getAttribute('data-price'), 10) || 0;     // acompte / pers (cents)
      var compare = parseInt(btn.getAttribute('data-compare'), 10) || 0; // total / pers (cents)
      var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;         // chambre partagée = 2 (paire)
      // Page : TOUJOURS des montants par personne (le total pour 2 n'apparaît qu'au panier).
      var solde = compare - price;
      if (elAcompte) elAcompte.textContent = eur(price);         // acompte / pers
      if (elTotal) elTotal.textContent = eur(compare);           // prix total / pers
      if (elSolde) elSolde.textContent = eur(solde);             // solde / pers
      if (elNote) elNote.textContent = '· par personne';
      if (elVariant) elVariant.value = btn.getAttribute('data-vid') || '';
      if (elQty) elQty.value = qty;
    }
    rooms.forEach(function (btn) {
      btn.addEventListener('click', function () { applyRoom(btn); });
    });
    // Sélection initiale : la formule active si dispo, sinon la première non épuisée.
    var activeRoom = root.querySelector('.bz-room.is-active');
    if (isSold(activeRoom)) activeRoom = null;
    if (!activeRoom) {
      activeRoom = Array.prototype.slice.call(rooms).filter(function (b) { return !isSold(b); })[0] || null;
    }
    if (activeRoom) applyRoom(activeRoom);

    // Tout épuisé : on neutralise le bouton de réservation.
    var allSold = rooms.length > 0 && Array.prototype.slice.call(rooms).every(isSold);
    if (allSold) {
      var cta = root.querySelector('form.bz-resa-form button[type="submit"]');
      if (cta) { cta.disabled = true; cta.textContent = 'Complet'; cta.style.opacity = '.55'; cta.style.cursor = 'not-allowed'; }
    }

    /* ---------- Soumission AJAX du formulaire produit ---------- */
    var form = root.querySelector('form.bz-resa-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var idInput = form.querySelector('[data-variant-id]');
        if (!idInput || !idInput.value) return; // laisse le natif gérer
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '0.7'; }
        var qtyInput = form.querySelector('[data-qty-input]');
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: qty })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(function () { form.submit(); });
      });
    }

    /* ---------- Carrousel hébergement ---------- */
    var car = root.querySelector('[data-bz-carousel]');
    if (car) {
      var track = car.querySelector('.bz-heb-track');
      var slides = car.querySelectorAll('.bz-heb-slide');
      var dots = car.querySelectorAll('.bz-heb-dot');
      var capEl = car.querySelector('[data-bz-cap]');
      var hint = car.querySelector('[data-bz-hint]');
      var caps = [];
      slides.forEach(function (s) { caps.push(s.getAttribute('data-cap') || ''); });
      var n = slides.length, i = 0, timer = null, paused = false, touched = false, x0 = null;

      function go(k, manual) {
        i = ((k % n) + n) % n;
        if (track) track.style.transform = 'translateX(' + (-i * 100) + '%)';
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
        if (capEl) capEl.textContent = caps[i] || '';
        if (manual) { touched = true; if (hint) hint.style.display = 'none'; restart(); }
      }
      function next(m) { go(i + 1, m); }
      function start() { stop(); if (paused) return; timer = setInterval(function () { if (!paused) next(false); }, 4200); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { start(); }

      var prev = car.querySelector('[data-bz-prev]');
      var nxt = car.querySelector('[data-bz-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1, true); });
      if (nxt) nxt.addEventListener('click', function () { go(i + 1, true); });
      dots.forEach(function (d, di) { d.addEventListener('click', function () { go(di, true); }); });

      car.addEventListener('mouseenter', function () { paused = true; stop(); });
      car.addEventListener('mouseleave', function () { paused = false; start(); });
      car.addEventListener('touchstart', function (e) { x0 = (e.touches && e.touches[0]) ? e.touches[0].clientX : null; paused = true; stop(); }, { passive: true });
      car.addEventListener('touchend', function (e) {
        if (x0 != null) {
          var t = e.changedTouches && e.changedTouches[0];
          if (t) { var dx = t.clientX - x0; if (Math.abs(dx) > 40) { dx < 0 ? next(true) : go(i - 1, true); } }
          x0 = null;
        }
        setTimeout(function () { paused = false; start(); }, 5000);
      }, { passive: true });

      go(0, false);
      start();
    }

    /* ---------- Reveal au scroll (one-shot, fiable jusqu'en bas de page) ---------- */
    var reveals = root.querySelectorAll('[data-reveal]');
    if (reveals.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
        reveals.forEach(function (el) { io.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('is-in'); });
      }
    }

    /* ---------- Barre mobile : n'apparaît qu'au scroll ---------- */
    var bottomBar = root.querySelector('[data-sticky-bottom]');
    if (bottomBar) {
      var onScrollBar = function () {
        bottomBar.classList.toggle('is-shown', (window.scrollY || window.pageYOffset || 0) > 140);
      };
      window.addEventListener('scroll', onScrollBar, { passive: true });
      onScrollBar();
    }
  }

  function boot() {
    document.querySelectorAll('.dm-bz').forEach(function (root) {
      if (root.getAttribute('data-bz-ready')) return;
      root.setAttribute('data-bz-ready', '1');
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
